module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.photos.length > 0 || _vm.isOwnProfile) ? _c('h1', [_vm._v("Photos")]) : _vm._e(), _vm._v(" "), (_vm.photos.length > 0 || _vm.isOwnProfile) ? _c('div', {
    staticClass: "photos"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "upload-file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadPhoto
    }
  }), _vm._v(" "), _vm._l((_vm.photos), function(photo) {
    return [_c('div', {
      staticClass: "photo-container"
    }, [_c('div', {
      staticClass: "photo",
      style: (("background-image: url('/profilePhotos/member_" + _vm.memberId + "/" + (photo.photoUrl) + "')")),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showInModal(photo)
        }
      }
    }), _vm._v(" "), (_vm.isOwnProfile) ? _c('button', {
      staticClass: "photo-button",
      attrs: {
        "disabled": _vm.deletingPhoto
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deletePhoto(photo)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e()])]
  }), _vm._v(" "), (_vm.isOwnProfile && !_vm.isUploading) ? _c('label', {
    staticClass: "add-photo",
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v("Add a Photo")]) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && _vm.isUploading) ? _c('button', {
    staticClass: "add-photo",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Uploading...")]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18526557"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProfilePage/PhotoManager.vue
// module id = 391
// module chunks = 1